var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3384_2900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61606 6.0503L5.61594 9.28525C5.53822 9.36915 5.44593 9.4357 5.34434 9.48111C5.24274 9.52653 5.13385 9.5499 5.02387 9.5499C4.9139 9.5499 4.805 9.52653 4.70341 9.48111C4.60182 9.4357 4.50952 9.36915 4.4318 9.28525L0.837524 5.41413V0.902344H5.02178L8.61606 4.77797C8.77192 4.94704 8.85941 5.17574 8.85941 5.41413C8.85941 5.65252 8.77192 5.88123 8.61606 6.0503V6.0503Z",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92847 3.1582H2.93265",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3384_2900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.0422,
    height: 10.8283,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.0f3ead57119659d9d0c2dc95dae1c187.svg";
export { ForwardRef as ReactComponent };